module.exports = __webpack_public_path__ + "static/img/index1(1)_03.b338341.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index1(1)_03.png
// module id = 3115
// module chunks = 1